import { motion } from "framer-motion";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

export const AboutUsListing = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const bgImagePath = `${window.location.origin}/image/landingPage/about.png`;

  return (
    <div id="about">
      <div
        className="relative min-h-screen bg-center bg-cover"
        style={{
          backgroundImage: `url('${bgImagePath}')`,
        }}
      >
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-20">
          <div className="container flex flex-col items-center justify-between w-full h-full px-4 py-32 mx-auto">
            <motion.div
              className="container mx-auto md:hidden"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="mb-6 text-2xl font-bold text-white">
                {intl.formatMessage({ id: "aboutUs.title" })}
              </div>
            </motion.div>
            <motion.div
              className="bg-[#d0cece] h-full w-full bg-opacity-90 py-6 px-4 md:px-20 flex flex-col justify-center"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="hidden mb-16 text-3xl font-bold md:flex">
                {intl.formatMessage({ id: "aboutUs.title" })}
              </div>
              <div className="border-l-4 ps-4 border-[#6e5f49] mb-6 md:mb-16 md:pe-48 md:text-xl">
                <div className="mb-4 md:mb-6">
                  {intl.formatMessage({ id: "aboutUs.desc1" })}
                </div>
                <div>{intl.formatMessage({ id: "aboutUs.desc2" })}</div>
              </div>
              <div className="hidden md:flex">
                <button
                  onClick={() => navigate("/quote/phone")}
                  className="bg-[#6b5c45] border-2 border-[#3f3525] text-white px-4 py-2 rounded-full hover:bg-[#3f3525] transition font-semibold"
                >
                  {intl.formatMessage({ id: "getQuotation" })}
                </button>
              </div>
            </motion.div>
            <div className="container pt-6 mx-auto md:hidden">
              <button
                onClick={() => navigate("/quote/phone")}
                className="bg-[#6b5c45] border-2 border-[#3f3525] text-white px-4 py-2 rounded-full hover:bg-[#3f3525] transition font-semibold"
              >
                {intl.formatMessage({ id: "getQuotation" })}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
